import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TowageEditComponent } from './towage-edit.component';

const routes: Routes = [
  {
    path: '',
    component: TowageEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TowageEditRoutingModule {}
